import { CloudBracesIcon } from './CloudBracesIcon';

/**
 * author: Andy Martinez
 * id 6ED02FDD-323E-4004-9D7B-336F2402DF8E
 * name cloud-braces
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud-braces.svg
 * tags
 * - Cloud 
 * - Developer / Languages 
 */
export const CloudJsonIcon = CloudBracesIcon;
export default CloudJsonIcon